import { Fragment, useState } from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import {
  AccountCircleOutlined,
  LogoutOutlined,
  NotificationsOutlined,
  ExpandMore,
} from '@mui/icons-material';
import useUser from 'store/user/useUser';
import { useNavigate } from 'react-router-dom';
import useStudent from 'store/student/useStudent';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import useNotification from 'hooks/useNotification';
import { IToggleObj } from './type';
import { initialToggleObj } from './initialStates';
import Survey from '../Survey';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
}

const MenuSettings = (props: Props) => {
  const { menuDrawerWidth, setMenuDrawerWidth } = props;

  const navigate = useNavigate();
  const { onSignOut } = useUser();
  const { onCloseReadOnly, onUpdateSurveyType } = useSurvey();
  const { student_uuid, onResetStudent } = useStudent();
  const { patientInfo, onSelectedPatient, onResetPatient } = usePatient();
  const { onRequired } = useNotification();

  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);

  const settings = [
    {
      icon: <NotificationsOutlined />,
      label: 'Зарлал',
    },
    {
      icon: <AccountCircleOutlined />,
      label: 'Хувийн тохиргоо',
    },
    {
      icon: <LogoutOutlined />,
      label: 'Гарах',
    },
  ];

  const onClickListItem = (label: string) => {
    if (label === 'Гарах') {
      if (sessionStorage.getItem('MODE') === 'TEST') {
        setTimeout(() => {
          window.location.reload();
        }, 100);
        onSignOut();
        // 로그아웃 시 스토어 초기화
        onResetStudent();
        onResetPatient();
        onCloseReadOnly();
      }
      onSignOut();
      // 로그아웃 시 스토어 초기화
      onResetStudent();
      onResetPatient();
      onCloseReadOnly();
      sessionStorage.removeItem('MODE');
    } else if (label === 'Хувийн тохиргоо') {
      navigate('/mypage');
      return;
    } else if (label === 'Screen Settings') {
      navigate('/screensetting');
      return;
    } else if (label === 'Зарлал') {
      window.open('https://smartenr.com/notice');
      return;
    } else if (!patientInfo) return onRequired('REQUIRED.PATIENT');
    onUpdateSurveyType(label);
  };

  const onClickDisabledItem = (sublabel: string | undefined) => {
    let newToggle = { ...toggle };

    if (menuDrawerWidth !== 220) {
      if (sublabel) newToggle[sublabel] = true;
      setToggle(newToggle);
      setMenuDrawerWidth(220);
      return;
    }

    if (sublabel) newToggle[sublabel] = !newToggle[sublabel];
    setToggle(newToggle);
  };

  return (
    <Fragment>
      {settings.map(({ icon, label }) => {
        const onClick = () => {
          onClickListItem(label);
        };

        const MoreIcon = () => {
          return <ExpandMore fontSize="small" sx={{ color: '#fff' }} />;
        };

        // 축소된 메뉴 (52px)
        if (menuDrawerWidth !== 220) {
          if (!icon) return null;

          return (
            <Tooltip
              key={label}
              title={label}
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                    padding: '8px 12px',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                  },
                },
                arrow: {
                  sx: {
                    color: 'rgba(0, 0, 0, 0.9)',
                  },
                },
              }}
            >
              <ListItem disablePadding>
                <ListItemButton onClick={onClick}>
                  <ListItemIcon>{icon}</ListItemIcon>
                </ListItemButton>
              </ListItem>
            </Tooltip>
          );
        }

        // 확장된 메뉴 (220px)
        if (icon) {
          return (
            <ListItem key={label} disablePadding>
              <ListItemButton onClick={onClick}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={label} />
              </ListItemButton>
            </ListItem>
          );
        }

        if (toggle) {
          return (
            <ListItem key={label} disablePadding>
              <ListItemButton onClick={onClick}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={label} sx={{ whiteSpace: 'pre-wrap' }} />
              </ListItemButton>
            </ListItem>
          );
        }

        return null;
      })}
      <Survey />
    </Fragment>
  );
};

export default MenuSettings;
